import React from 'react'
import { ButtonText, Headline4, Subtitle1 } from 'stories/elements/Typography/Text'
import theme from 'stories/utils/theme'
import styled, { css } from 'styled-components'
import { NewButtonLink } from 'components/elements/NewButton'

const Container = styled.div`
    height: 100%;
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: 30px;
    padding-bottom: 50px;
    a {
        width: 800px;
    }
    @media (max-width: 1050px) {
        height: auto;
        a {
            width: 100%;
        }
    }
    h5 {
        width: 100%;
    }
`

const Grid = styled.div<{ alignRow?: boolean }>`
    ${({ alignRow }) =>
        alignRow
            ? css`
                  display: flex;
                  flex-wrap: wrap;
                  gap: 30px;
                  justify-content: center;
              `
            : css`
                  display: grid;
                  grid-template-columns: 1fr;
              `}

    row-gap: 30px;
    padding-bottom: 25px;
`

const InformationListCard = styled.div<{ isVertical?: boolean }>`
    height: auto;
    background-color: ${theme.colors.white};
    border: 2px solid ${theme.colors.violet};
    border-radius: ${theme.borderRadius.normal};

    ${({ isVertical }) =>
        isVertical
            ? css`
                  width: 100%;
                  display: grid;

                  grid-template-rows: 115px auto;

                  @media (max-width: 750px) {
                      grid-template-rows: 1fr;
                  }
              `
            : css`
                  width: 800px;
                  display: grid;
                  .subtitle {
                      gap: 10px;
                      display: flex;
                      align-items: center;
                  }
                  gap: 10px;
                  align-items: center;
                  padding: 20px;

                  @media (max-width: 1050px) {
                      width: 600px;
                  }
              `}
    @media (max-width: 750px) {
        width: 100%;
    }
`

interface Props {
    center?: boolean
    buttonText?: string
    buttonTarget?: string
    alignRow?: boolean
    items: {
        title?: string
        subtitle?: string
        icon?: StaticImageData
    }[]
}

const InformationGrid = ({ items, buttonTarget, buttonText, alignRow, center }: Props) => {
    return (
        <Container>
            <Grid alignRow={alignRow}>
                {items.map(({ icon, title, subtitle }, i) => (
                    <InformationListCard key={`information-list-card-${i}`} isVertical={alignRow}>
                        {title ? (
                            <Headline4
                                color={theme.colors.deepSeaBlue}
                                marginBottom={10}
                                textAlign={center ? 'center' : 'left'}
                            >
                                {title}
                            </Headline4>
                        ) : null}
                        <div className="subtitle">
                            {icon ? (
                                <img src={icon.src} height={icon.height} width={icon.width} alt={title || subtitle} />
                            ) : null}
                            <Subtitle1
                                fontFamily="var(--font-inter)"
                                fontWeight={400}
                                color={theme.colors.actionGray}
                                textAlign={center ? 'center' : 'left'}
                            >
                                {subtitle}
                            </Subtitle1>
                        </div>
                    </InformationListCard>
                ))}
            </Grid>
            {buttonText && buttonTarget ? (
                <NewButtonLink
                    color={theme.colors.deepSeaBlue}
                    href={buttonTarget}
                    borderRadius={theme.borderRadius.normal}
                    fullWidth
                    height={50}
                >
                    <ButtonText color={theme.colors.white}>{buttonText}</ButtonText>
                </NewButtonLink>
            ) : null}
        </Container>
    )
}

export default InformationGrid
